import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

const Portal = ({ children, containerId }) => {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)

		return () => setMounted(false)
	}, [])

	return mounted ?
		createPortal(children, document.getElementById(containerId))
		: children
}

export default Portal
